import { ArraySerializer, Field, Model, PrimitiveSerializer, Type } from 'serialize-ts';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';
import { Organization } from '~app/modules/product/models/organization.model';
import { BusinessModel } from '~app/modules/product/models/business-model.model';
import { ProductIndexPromotion } from '~app/modules/product/models/product-index-promotion.model';
import { ProductIndexOfferService } from '~app/modules/product/models/product-index-offer-service.model';
import { ProductIndexRegionInfo } from '~app/modules/product/models/product-index-region-info.model';
import { OfferLabels } from '~app/modules/product/enums/offer-labels.enum';
import { ShippingGroup } from './shipping-group.model';
import { VAS } from './value-added-service.model';

@Model()
export class ProductIndexOffer {
  @Field()
  id: string;

  @Field()
  quantity: number;

  @Field()
  freightForwarding: boolean;

  @Field()
  organization: Organization;

  @Field()
  promotion: ProductIndexPromotion;

  @Field()
  businessModel: BusinessModel;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(ProductIndexOfferService)))
  offerServices: ProductIndexOfferService[];

  @Field()
  originRegionInfo: ProductIndexRegionInfo;

  @Field()
  destinationRegionInfo: ProductIndexRegionInfo;

  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  labels: OfferLabels[];

  @Field()
  shippingGroup?: ShippingGroup;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(VAS)))
  valueAddedServices?: VAS[];
}
